import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import withSizes from 'react-sizes';
import { ESTADOS_FORM, ACCIONES_GRID } from 'skrit-web-framework/constantes';
import { getBreakpoints, getListado } from 'skrit-web-framework/utils';
import { desbloquearRegistro } from 'skrit-web-framework/actions';
import Drawer from 'skrit-web-framework/components/Drawer';
import Ficha from 'skrit-web-framework/fichas';
import translate from 'skrit-web-framework/translator';
import cls from 'classnames';

import { GRIDS, FICHAS } from '../../utils/ConstantesComunes';
import { enviarEmailPDF } from '../../utils/utils';

const mapDispatchToProps = dispatch => {
    return {
        setNotifications(count) {
            dispatch({ type: 'SET_NOTIFICATION_COUNT', value: count });
        }
    };
};

class Notifications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            notifications: [],
            notificationToSend: null
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.open) {
            if (prevProps.open !== this.props.open) {
                this.getData();
            }
        }
    }

    getData() {
        getListado(GRIDS.ALERTAS.controller, []).then(res => {
            if (res.rows) {
                this.setState({ notifications: res.rows });
                this.props.setNotifications(res.rows.length);
            }
        });
    }

    handleRemove = id => () => {
        let reg = this.state.notifications.find(e => e.AVI_ID === id);
        desbloquearRegistro({
            endpoint: GRIDS.ALERTAS.controller,
            estado: ESTADOS_FORM.CONSULTA,
            payload: {
                Accion: ACCIONES_GRID.BAJA,
                Reg: reg
            }
        }).then(() => {
            this.getData();
        });
    };

    sendMail = id => () => {
        let reg = this.state.notifications.find(e => e.AVI_ID === id);
        let mailParams = {
            CorreosDestinatarios: reg.CLI_EMAIL,
            Asunto: reg.AVI_TITULO,
            CC: '',
            Cuerpo: reg.AVI_DESCRIPCION,
            DocumentosAdjuntos: []
        };
        this.setState({ notificationToSend: mailParams });
    };

    onMailAccepted = res => {
        this.setState({ notificationToSend: null }, () => {
            enviarEmailPDF(res);
        });
    };

    onMailCanceled = () => {
        this.setState({ notificationToSend: null });
    };

    renderMailForm() {
        return (
            <Ficha
                ficha={FICHAS.MAIL_FORM}
                open={!!this.state.notificationToSend}
                estado={ESTADOS_FORM.EDICION}
                reg={this.state.notificationToSend}
                accept={this.onMailAccepted}
                cancel={this.onMailCanceled}
            />
        );
    }

    renderNotifications() {
        return this.state.notifications
            .filter(notification => notification.AVI_MOSTRAR)
            .map(notification => (
                <li key={notification.AVI_ID}>
                    <div className='notification'>
                        <div className='notification-header'>
                            <span className='notification-title'>
                                {notification.AVI_TITULO}
                            </span>
                            <button
                                className='btn'
                                onClick={this.handleRemove(notification.AVI_ID)}
                            >
                                <i className='ms-Icon ms-Icon--Cancel' />
                            </button>
                        </div>
                        <div className='notification-content'>
                            <span>{notification.AVI_DESCRIPCION}</span>
                        </div>
                        <div className='notification-actions'>
                            <button
                                className='btn'
                                onClick={this.sendMail(notification.AVI_ID)}
                            >
                                <span>{translate('enviar_email')}</span>
                            </button>
                        </div>
                    </div>
                </li>
            ));
    }

    render() {
        const { isMobile, open, onClose } = this.props;
        return (
            <Fragment>
                <Drawer
                    open={open}
                    className={cls('dark-sidebar', { mobile: isMobile })}
                    position='left'
                    width={isMobile ? '100vw' : '500px'}
                    onClose={onClose}
                    allowDismiss
                >
                    <div className='drawer-header'>
                        <button className='btn' onClick={onClose}>
                            <i className='ms-Icon ms-Icon--ChevronLeft' />
                            {translate('alertas')}
                        </button>
                    </div>
                    <ul className='links'>{this.renderNotifications()}</ul>
                </Drawer>
                {this.renderMailForm()}
            </Fragment>
        );
    }
}

export default withSizes(getBreakpoints)(
    connect(
        null,
        mapDispatchToProps
    )(Notifications)
);
